<template>
  <div class="container-autocomplete" v-if="results !== null ">
    <div v-for="(item, index) in results" :key="index" class="autocomplete">
      <a :href="item.is_document ? item.is_document : item.link" v-if="item.title" :target="item.is_document ? '_blank' : '_self'">
        <WordHighlighter :query="query" :splitBySpace="true" :highlightClass="'highlight'">
          {{ item.title.rendered }}
        </WordHighlighter>
      </a>
    </div>
    <a class="btn-secondary" href="#" target="" @click="$parent.selectResult" v-if="!noResu">{{ textCta }}</a>
  </div>
</template>
<script>
import WordHighlighter from "vue-word-highlighter";
export default {
  components: {
    WordHighlighter,
  },
  props: {
    results: {
      type: [Object, Array],
      required: true,
    },
    query: {
      type: [String, Number],
      required: true,
      default: null,
    },
    textCta : {
      type:String,
      required: true
    },
    noResu : {
      type: Boolean,
      required: true,
    }
  },

}
</script>

<style lang="scss" scoped>

</style>
